import ActionType from 'actions/ActionType'

export default (
  state = { value: null, initialValue: null, users: null, setByTask: false },
  action,
) => {
  switch (action.type) {
    case ActionType.Data.LIST_SUCCESS:
      if (
        action.entityType === 'phonenumbers' &&
        action.payload &&
        !state.setByTask
      ) {
        if (action.payload.length === 1) {
          return {
            value: action.payload[0].phone_number,
            initialValue: action.payload[0].phone_number,
          }
        }

        const defaultPhone =
          Array.isArray(action.payload) &&
          action.payload.find(element => element.default)
        if (defaultPhone) {
          return {
            value: defaultPhone.phone_number,
            initialValue: defaultPhone.phone_number,
          }
        }
        return state
      }
      return state
    case ActionType.Data.UPDATE_SUCCESS:
      if (action.entityType === 'phonenumbers') {
        if (action.payload.default) {
          return {
            ...state,
            value: action.payload.phone_number,
            initialValue: action.payload.phone_number,
          }
        }
        return state
      }
      return state
    case ActionType.Data.CREATE_SUCCESS:
      if (action.entityType === 'phonenumbers') {
        if (action.payload.default) {
          return {
            ...state,
            value: action.payload.phone_number,
            initialValue: action.payload.phone_number,
          }
        }
      }
      return state
    case ActionType.Tasks.SELECT_FROM_NUMBER:
      return { ...state, value: action.payload.value }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.payload.send_sms) {
        return {
          setByTask: true,
          value: action.payload.send_sms.trigger_data.from_number,
          initialValue: action.payload.send_sms.trigger_data.from_number,
        }
      }

      return {
        setByTask: false,
        value: action.defaultPhoneNumber,
        initialValue: action.defaultPhoneNumber,
      }
    case ActionType.Tasks.VALIDATION_FAILURE:
      const dup = state
      action.errors.forEach(error => {
        if (error.dataPath === '.send_sms.trigger_data.from_number') {
          dup.error = error.message
        }
      })
      return dup
    default:
      return state
  }
}
